import type { MouseEvent } from "react";
import { t } from "@/i18n-js/instance";
import { formatFileSize } from "@circle-react/helpers/fileSizeHelpers";
import { Button } from "@circle-react-shared/uikit/Button";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { FileTypeIcon } from "@circle-react-shared/uikit/TipTap/AttachmentPreviews/FileTypeIcon";
import { Typography } from "@circle-react-shared/uikit/Typography";

export interface ReplaceMediaButtonProps {
  byte_size?: number;
  filename?: string;
  onClickRemove: (e?: MouseEvent<HTMLButtonElement>) => void;
  onClickReplace: (e?: MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
}

export const ReplaceMediaButton = ({
  filename = "",
  byte_size = 0,
  onClickReplace,
  onClickRemove,
}: ReplaceMediaButtonProps) => {
  const maxFilenameLength = 20;
  const truncatedFilename = filename.slice(0, maxFilenameLength);
  const isTruncated = filename.length > maxFilenameLength;
  return (
    <button
      type="button"
      className="border-primary divide-primary bg-primary flex w-full flex-col divide-y rounded-lg border text-left"
      onClick={onClickReplace}
    >
      {filename && (
        <div className="p-3">
          <div className="m-2 flex flex-col items-center gap-2">
            <FileTypeIcon content_type="file" />
            <Typography.LabelSm weight="semibold">
              <span className="line-clamp-1 truncate">
                {isTruncated ? `${truncatedFilename}...` : filename}
              </span>
            </Typography.LabelSm>
            <Typography.LabelXs weight="regular">
              {formatFileSize(byte_size)}
            </Typography.LabelXs>
          </div>
        </div>
      )}
      <div className="flex justify-between px-3 py-2">
        <Button onClick={onClickReplace} variant="text" small>
          {t("builder_ui.prop_type.attachment_upload.replace")}
        </Button>
        <IconButton
          name="20-trash-bin"
          iconSize={20}
          buttonSize={28}
          className="text-dark"
          onClick={onClickRemove}
          title={t("builder_ui.prop_type.attachment_upload.delete")}
          ariaLabel={t("builder_ui.prop_type.attachment_upload.delete")}
        />
      </div>
    </button>
  );
};
